import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import editIcon from "../../../assets/img/small-logos/edit_icon.svg"
import deleteIcon from "../../../assets/img/small-logos/delete _icon.svg";
import Swal from "sweetalert2";
import eye from "../../../assets/img/icons/eye-solid.svg"
import profileIcon from "../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg";
import "./Users.css";
import LoadingGif from "src/components/layout/Loader";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { IUser } from "src/helper/interfaces";
import Cookies from "js-cookie";
import { setSearchValue } from "src/store/searchValue/searchValueSlice";
import Paginator from "src/components/layout/Paginator";
import { formatDiffrentDate } from "src/utils/normalFuntions";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import ExportDocs from "src/components/layout/ExportDocs";
import { Link } from "react-router-dom";

const getAllUsers = async (token: string, pageNumber: number, pageSize: number, searchValue: string, startDate?: string, endDate?: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/all-users`, {
      headers: {
         "x-access-token": token
      },
      params: {
         page: pageNumber,
         search_value: searchValue,
         pageSize: pageSize,
         start_date: startDate,
         end_date: endDate
      }

   })
};

const Users = () => {

   const [searchVal, setSearchVal] = useState("");

   const Token = Cookies.get("token");
   const [users, setUsers] = useState<any[]>([])
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const [startDate, setStartDate] = useState<Date | undefined>(undefined);
   const [endDate, setEndDate] = useState<Date | undefined>(undefined);
   const startingDate = startDate ? startDate.toISOString() : undefined;
   const endingDate = endDate ? endDate.toISOString() : undefined;


   useEffect(() => {
      dispatch(startLoading());
      getAllUsers(Token as string, pageNo, pageSize, searchVal, startingDate, endingDate).then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {
            setUsers(res?.data?.data?.data);
            setTotalPages(res?.data?.data?.totalPages);
            dispatch(stopLoading());
         } else {
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: `${res?.data?.data?.msg}`,
            });
         }
      }).catch((err) => {
         console.log(err);
         throw err;
      });
   }, [Token, pageNo, searchVal, pageSize, startDate, endDate])

   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);


   useEffect(() => {
      dispatch(setSearchValue(""))
   }, []);


   const handleDeleteConfirmed = (id: string) => {

      if (Token === undefined) {
         console.error("Token is undefined");
         return;
      }
      // Dispatch the delete action here
      Swal.fire({
         title: 'Are you sure?',
         text: "You cant't revert this!",
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'Yes, delete user!'
      }).then(async (response) => {
         if (response.isConfirmed) {

            await axios({
               url: `${AppConfig.DEV_SERVER}/user/${id}`,
               method: "DELETE",
               headers: {
                  'content-type': 'multipart/form-data',
                  "x-access-token": Token,
               }
            }).then((res) => {
               // console.log(res)
               Swal.fire(
                  'Deleted!',
                  `${res?.data?.msg}`,
                  'success'
               ).then(() => {
                  getAllUsers(Token as string, pageNo, pageSize, searchVal, startingDate, endingDate).then((res) => {
                     // console.log(res)
                     if (res?.data?.status_code === 200) {
                        setUsers(res?.data?.data?.data);
                        setTotalPages(res?.data?.data?.totalPages)
                     } else {
                        Swal.fire({
                           icon: "error",
                           title: "Oops...",
                           text: `${res?.data?.data?.msg}`,
                           footer: '<a href="#">Why do I have this issue?</a>'
                        });
                     }
                  })
               })

            }).catch((err) => {
               console.log(err)
            })  // Clear the selectedFoodItem state after updating
            // setModalShow(false);
         }
      }
      )
   };

   // const istDate = moment(selectedUser?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm A');
   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };

   const doc = new jsPDF();
   doc.text("Transactions Report", 14, 10);
   const formattedData = users.map((item: IUser, i) => {
      const address = `${item?.address?.street || ''}, ${item?.address?.city || ''}, ${item?.address?.state || ''}, ${item?.address?.country || ''} - ${item?.address?.pin_code || ''}`;
      return {
         no: i + 1,
         _id: item?._id || "",
         name: item?.name || "",
         dial_code: item?.dial_code || "",
         phone: item?.phone || "",
         is_otp_verified: item?.is_otp_verified ? "Yes" : "No",
         is_user_verified: item?.is_user_verified ? "Yes" : "No",
         is_user_details_completed: item?.is_user_details_completed ? "Completed" : "Incompleted",
         address: item?.address ? address : "NA",
         date: new Date(item.createdAt).toLocaleDateString(),
      };
   });

   const headers = [
      { label: "No", key: "no" },
      { label: "User Id", key: "_id" },
      { label: "Name", key: "name" },
      { label: "Dial Code", key: "dial_code" },
      { label: "Phone", key: "phone" },
      { label: "Otp Verified", key: "is_otp_verified" },
      { label: "User Verified", key: "is_user_verified" },
      { label: "User Details", key: "is_user_details_completed" },
      { label: "Address", key: "address" },
      { label: "Date", key: "date" }

   ];

   const exportPDF = () => {
      const doc = new jsPDF();

      // Sample headers and data
      const tableColumns = ["No", "Name", "Dial Code", "Phone", "Otp Verified", "User Verified", "User Details", "Address", 'Date'];
      const tableData = formattedData.map(item => [
         item.no || 0,
         // item._id || '',
         item.name || '',
         item.dial_code || '',
         item.phone || '',
         item.is_otp_verified || "",
         item.is_user_verified || '',
         item.is_user_details_completed || '',
         item.address || '',
         item.date || ''
      ]);

      // Use autoTable with the doc object
      autoTable(doc, {
         head: [tableColumns],
         body: tableData,
      });

      // Save the generated PDF
      doc.save('transactions.pdf');
   };

   // const handleInvoiceClick = async (id: string, order_type: string) => {
   //    console.log(order_type, id)
   //    if (!id) return;
   //    dispatch(startLoading());
   //    try {
   //       const res = await axios.get(`${AppConfig.DEV_SERVER}/invoice/${id}`, {
   //          headers: {
   //             "x-access-token": Token,
   //          },
   //          params: {
   //             type: order_type,
   //          },
   //       });
   //       // console.log(res)
   //       if (res?.data?.status_code === 200) {
   //          dispatch(stopLoading());
   //          const pdfUrl = res?.data?.data?.file;
   //          // setPdf(pdfUrl);
   //          window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
   //       } else {
   //          dispatch(stopLoading());
   //          Swal.fire({
   //             icon: "error",
   //             title: "Something Went Wrong...",
   //             text: `${res?.data?.msg}`,
   //          });
   //       }
   //    } catch (error) {
   //       dispatch(stopLoading());
   //       Swal.fire({
   //          icon: "error",
   //          title: "Error",
   //          text: "Failed to fetch the invoice.",
   //       });
   //    }
   // };

   const handlePageSizeChange = (e: any) => {
      setPageSize(e.target.value);
   }

   return (
      <MainLayout
         showAllFilters={false}
         searchValue={searchVal}
         clearValChange={clearSearchValue}
         onChange={(e) => setSearchVal(e.target.value)}
         startDate={startDate}
         endDate={endDate}
         startDateOnChange={e => setStartDate(e)}
         endDateOnChange={e => setEndDate(e)}

      >

         <div className=" main-div">

            <div className={`category-main me-2 p-3 p-md-4 card `}>
               {
                  loading ?
                     <div>
                        <LoadingGif />
                     </div>

                     : ""
               }
               {

                  <div>
                     <div className="d-flex justify-content-end gap-3 mb-3">
                        <div className="d-flex gap-2">
                           <span className="d-flex align-items-center pagesize-text">
                              PageSize
                           </span>

                           <select
                              className="form-select"
                              style={{ backgroundPosition: "right 5px center", width: "60px" }}
                              aria-label="Default select example"
                              value={pageSize} // Bind the value to the state
                              onChange={handlePageSizeChange} // Handle the change
                           >
                              <option value={20}>20</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                              <option value={200}>200</option>
                           </select>
                        </div>

                        <ExportDocs headers={headers} formattedData={formattedData} clickHandler={exportPDF} />
                     </div>
                     <div className="table-responsive">
                        <table className="table table-striped card-body">
                           <thead>
                              <tr className="category-tr " >
                                 <th scope="col" className="text-start ps-4">Sr.No.</th>
                                 <th scope="col" className="text-start ps-4">Profile Pic</th>
                                 <th scope="col" className="text-start ps-4">Name</th>
                                 <th scope="col" className="text-start ps-4">Email</th>
                                 <th scope="col" className="text-start ps-4">Phone No</th>
                                 <th scope="col" className="text-start ps-4">Otp Verified</th>
                                 <th scope="col" className="text-start ps-4">User Verified</th>
                                 <th scope="col" className="text-start ps-4">City/State</th>
                                 <th scope="col" className="text-start ps-4">Joined At</th>

                                 <th scope="col" className="col-lg-2 ps-4 ">Action</th>
                              </tr>
                           </thead>
                           <tbody>
                              {
                                 users && users?.map((data: IUser, i) => {
                                    // const joinDate = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                    const joinDate = formatDiffrentDate(data?.createdAt);

                                    const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                                    return (
                                       <tr key={data?._id}>

                                          <td className="text-start align-content-center ps-4">
                                             <span className="">
                                                {rowNumber}
                                             </span>

                                          </td>
                                          <td className="text-start align-content-center">
                                             {
                                                data?.profile_pic ?
                                                   <span className="d-flex align-items-center ">
                                                      <img src={data?.profile_pic} alt="profile-pic" className="profile-pic" />
                                                   </span>
                                                   :
                                                   <span className="d-flex align-items-center ">
                                                      <img src={profileIcon} alt="profileIcon" className="profile-pic" />
                                                   </span>
                                             }
                                          </td>

                                          <td className="text-start align-content-center ps-4" width={"160px"}>
                                             <span className="">
                                                {data?.name}
                                             </span>

                                          </td>
                                          <td className="text-start align-content-center ps-4">
                                             <span className="">
                                                {data?.email ? data?.email : "NA"}
                                             </span>

                                          </td>

                                          <td className="text-start align-content-center ps-4 ">
                                             <span className=" align-items-center">
                                                {data?.phone}
                                             </span> </td>

                                          <td className="icon-td align-content-center text-start ps-4">
                                             {data?.is_otp_verified ? "true" : "false"}
                                          </td>

                                          <td className="icon-td align-content-center text-start ps-4">
                                             {data?.is_user_details_completed ? "true" : "false"}
                                          </td>
                                          <td className="icon-td align-content-center text-start ps-4">
                                             {
                                                !data?.address?.city && !data?.address?.state ? "NA" :
                                                   `${data?.address?.city ?? "NA"}, ${data?.address?.state ?? "NA"}`
                                             }
                                          </td>
                                          <td className="icon-td align-content-center text-start ps-4" width={"160px"}>
                                             {joinDate?.formattedDate}, <br />{joinDate?.formattedHours}
                                          </td>
                                          <td className="align-content-center ">
                                             <div className="d-flex justify-content-center gap-3 align-items-center">

                                                <Link to={`/users/edit/${data?._id}`}>
                                                   <button className="btn btn-sm edit_btn">
                                                      <img src={editIcon} />
                                                   </button>
                                                </Link>
                                                <Link to={`/users/${data?._id}`}>
                                                   <button className="btn btn-sm delete_btn">
                                                      <img src={eye} />
                                                   </button>
                                                </Link>
                                                <button className="btn btn-sm delete_btn " onClick={() => handleDeleteConfirmed(data?._id)}>
                                                   <img src={deleteIcon} />
                                                </button>
                                             </div>

                                          </td>
                                       </tr>
                                    )
                                 }
                                 )
                              }

                           </tbody>
                        </table>
                     </div>
                     <Paginator
                        totalPages={totalPages}
                        pageNo={pageNo}
                        onPageChange={(e, no) => setPageNo(no)}
                        alignment="right"
                     />
                  </div>
               }

            </div>

         </div>

      </MainLayout>
   )

};



export default Users;